import { render, staticRenderFns } from "./listaTipoProduto.vue?vue&type=template&id=c51f41d2&scoped=true"
import script from "./listaTipoProduto.vue?vue&type=script&lang=js"
export * from "./listaTipoProduto.vue?vue&type=script&lang=js"
import style0 from "./listaTipoProduto.vue?vue&type=style&index=0&id=c51f41d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51f41d2",
  null
  
)

export default component.exports